module.exports = __webpack_public_path__ + "static/img/apple-download.fbae1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/apple-download.png
// module id = p7U1
// module chunks = 0